export { WipeTransition } from './wipe-transition';
